import React, { useState, useEffect, useRef } from 'react'
import '../App.css'
import axios from 'axios';
import { useAuthContext } from "../contexts/AuthContext";
import { api } from "../apiClient.js";

function DataSearch() {
  const [records, setRecords] = useState([]);
  const bottomRef = useRef(null);

  const { AuthData, updateAuthData } = useAuthContext();
  const [blobName, setBlobName] = useState("");
  const fetchBlobAndOpen = async (question) => {
    setBlobName(question);
    console.log("Blob Name Sent:", question); // 打印傳遞的 blobName
    try {
      // 向後端代理發送請求以獲取 Blob
      // const response = await axios.get("http://localhost:5000/download", {
      const response = await api.get("/download", {
        // headers: {
        //   Authorization: `Bearer ${AuthData.accessToken}`, // 傳入 accessToken
        // },
        params: { blobName: question }, // 傳遞 Blob 名稱作為參數
        responseType: "blob", // 返回二進制數據
      });
      console.log(response.data);

      // 將 Blob 轉換為 URL
      const blob = new Blob([response.data]);
      const blobUrl = window.URL.createObjectURL(blob);

      // 在新分頁中打開文件
      window.open(blobUrl, "_blank");

      console.log("Blob opened in new tab successfully!");
    } catch (error) {
      console.error("Error fetching and opening Blob:", error);
    }
  };

  // 在頁面載入時發送 API 請求
  // useEffect(() => {
  //   fetch('http://localhost:5000/ai-bot/user')
  //     .then(response => response.json())
  //     .then(data => {
  //       console.log(data)
  //       setRecords(data)})
  //     .catch(error => console.error('Error fetching records:', error));
  // }, []);

  // 每當 records 改變時，自動捲動到最底部
  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [records]);

  const [datas, setDatas] = useState([
    // { question: '問題1', answer: '回答1', id: Math.random() },
    // { question: '問題2', answer: '回答2', id: Math.random() },
  ]);
  const [error, setError] = useState("");
  // const addData = (question, answer) => {
  // setDatas((prevDatas) => 
  //   [...prevDatas, { question: question, answer: answer, id: Math.random() }]);
  // console.log(datas);

  // const addMultipleData = (newDataArray) => {
  //   setDatas((prevDatas) => {
  //     // 過濾掉已存在的資料
  //     const filteredNewData = newDataArray.filter(
  //       (newData) =>
  //         !prevDatas.some(
  //           (data) =>
  //             data.id === newData.id ||
  //             (data.question === newData.question && data.answer === newData.answer)
  //         )
  //     );

  //     // 合併舊資料與新資料
  //     return [...prevDatas, ...filteredNewData];
  //   });
  // };

  return (
    <div className='wrapper'>
      <div>Database Search</div>
      {/* <div className='question'>{datas[0].question}</div>
        <div className='response'>{datas[0].answer}</div> */}
      {records.map((record) => {
        return <AIReply record={record} />
      })}
      {datas.map((data) => {
        return (
          <>
            <div className='question'>{data.question}</div>
            <div className='response'>
              {/* {data.answer} */}
              {/* <div> */}
              {data.answer.split("\n").map((line, index) => (
                // <p key={index}>{line}</p>
                <button
                  onClick={() => fetchBlobAndOpen(data.question)}
                  key={index}
                >
                  {line}
                </button>
              ))}
              {/* </div> */}
            </div>
          </>
        )
      })}
      <div>{error}</div>
      {/* <div className='question'>{datas[datas.length - 1]['question']}</div>
        <div className='response'>{datas[datas.length - 1]['answer']}</div> */}
      {/* 用來觸發自動捲動的元素 */}
      <div ref={bottomRef} />
      <QuestionForm setDatas={setDatas} setError={setError} />
    </div>
  );
}

function QuestionForm({ setDatas, setError }) {
  // const [response, setResponse] = useState('');
  let response = '';
  const [content, setContent] = useState("");
  const handleSubmit = async (e) => {
    e.preventDefault()
    setDatas([]);

    // const handleAICall = async () => {
    try {
      // const result = await axios.post('http://localhost:5000/data-search', {
      const result = await api.post('/data-search', {
        // 傳遞的資料
        question: content
      }, {
        headers: { 'Content-Type': 'application/json' }
      });
      // console.log(result.data.response);
      // response = result.data.response;
      // console.log(response);
      // setResponse(result.data.response);
      console.log(result.data.results);

      // result.data.results.map((e) => {
      //   console.log(e.title);
      //   addData(e.title, e.file_url);
      // });

      // addData(result.data.results[0]['title'], result.data.results[0]['file_url'])

      // 格式化資料，確保有 question 和 answer
      const formattedResults = result.data.results.map((e) => ({
        question: e.title,
        answer: e.file_url,
        id: e.id,
      }));
      console.log(formattedResults);

      // 批量加入資料
      // addMultipleData(formattedResults);
      setDatas(formattedResults);
      setError('');
      setContent('')
    } catch (error) {
      console.error("呼叫失敗", error);
      console.error("呼叫失敗", error.response.data);
      setDatas([]);
      setError(error.response.data.error);
      }
    // };
  }

  return (
    <form className="create-form" onSubmit={handleSubmit}>
      <input type="text" placeholder="請輸入檔案關鍵字以取得網址"
        value={content}
        onChange={(e) => { setContent(e.target.value) }}
      />
      <button type="submit">送出</button>
    </form>
  );
}

function AIReply({ data, record }) {
  return (
    <div>
      <div className='question'>{record.question}</div>
      <div className='response'>{record.response}</div>
    </div>
  )
}

export default DataSearch;